// extracted by mini-css-extract-plugin
var _1 = "z8SXHwggOQIGXZPVJc3d";
export { _1 as "image" }
